
























































































import Vue from 'vue'
import Component from 'vue-class-component'
import Switcher from '@/components/Switcher.vue'
import {
  EAutoPayItemStatus,
  EAutoPaySettingStatus,
  EAutoPayType,
  EPaymentMethodType,
  EUserPermissions,
  IAutoPayItem,
  IFacility,
  IResident,
  IResidentPaymentMethod
} from '@zunta/configurations'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import { IAutoPaySetting } from '@zunta/configurations/dist/types/payments'
import Card from '@/components/Card.vue'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { User } from '@/classes/User'
import Api from '@/api'
import StatusAutoPaymentItem from '@/components/statuses/StatusAutoPaymentItem.vue'
import { AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP } from '@/constants'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'
import { getAutopayTooltipText } from '@/utils/helpers'

@Component({
  components: {
    PaymentMethodLabel,
    StatusAutoPaymentItem,
    Table,
    FacilityLabel,
    Card,
    Icon,
    Switcher,
    DateTimeLabel,
    ResidentLabel
  }
})
export default class PaymentsNeedsReview extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EAutoPaySettingStatus: any = EAutoPaySettingStatus
  EAutoPayItemStatus: any = EAutoPayItemStatus
  EAutoPayType: any = EAutoPayType
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  getAutopayTooltipText = getAutopayTooltipText

  showUpcoming: boolean = false

  filters: any = {
    skip: 0,
    limit: 20,
    statuses: this.queryStatuses || [EAutoPayItemStatus.NEEDS_REVIEW, EAutoPayItemStatus.DECLINED]
  }

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    usePagination: true,
    useQuery: true,
    fetchFunction: this.fetchAutopay,
    rowClick: this.user.hasPermissionFor(EUserPermissions.VIEW_AUTOPAY) ? this.goReview : undefined,
    maxHeight: 'calc(100vh - 465px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '120px',
        width: 15,
        key: 'facilityName',
        searchKey: 'facilityName',
        label: 'Facility',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 14,
        key: 'resident',
        searchKey: 'resident',
        label: 'Resident',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 12,
        key: 'paymentMethod',
        searchKey: 'paymentMethod',
        label: 'Payment Method',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 13,
        key: 'paymentType',
        searchKey: 'paymentType',
        label: 'Autopay Type',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.autoPayTypesList
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '160px',
        width: 12,
        key: 'status',
        searchKey: 'statuses',
        label: 'Status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.allowedStatusesList
      },
      {
        minWidth: '160px',
        width: 16,
        key: 'date',
        searchKey: 'date',
        label: 'Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '100px',
        width: 8,
        class: 'text-right',
        key: 'actions'
      }
    ]
  }

  get queryStatuses () {
    return this.$route.query.statuses
  }

  get autoPayItems () {
    return this.$store.state.payments.autoPayItems
  }

  get allowedStatusesList () {
    return [
      {
        key: EAutoPayItemStatus.NEEDS_REVIEW,
        value: EAutoPayItemStatus.NEEDS_REVIEW,
        content: AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP[EAutoPayItemStatus.NEEDS_REVIEW]
      },
      {
        key: EAutoPayItemStatus.DECLINED,
        value: EAutoPayItemStatus.DECLINED,
        content: AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP[EAutoPayItemStatus.DECLINED]
      },
      {
        key: EAutoPayItemStatus.UPCOMING,
        value: EAutoPayItemStatus.UPCOMING,
        content: AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP[EAutoPayItemStatus.UPCOMING]
      }
    ]
  }

  get autoPayTypesList () {
    return [
      {
        key: EAutoPayType.BILL_MAX_ONLY,
        value: EAutoPayType.BILL_MAX_ONLY,
        content: this.getAutoPayType(EAutoPayType.BILL_MAX_ONLY)
      },
      {
        key: EAutoPayType.BILL_ANYWAY,
        value: EAutoPayType.BILL_ANYWAY,
        content: this.getAutoPayType(EAutoPayType.BILL_ANYWAY)
      },
      {
        key: EAutoPayType.BILL_MONTH_DUE,
        value: EAutoPayType.BILL_MONTH_DUE,
        content: this.getAutoPayType(EAutoPayType.BILL_MONTH_DUE)
      },
      {
        key: EAutoPayType.BILL_FULL_DUE,
        value: EAutoPayType.BILL_FULL_DUE,
        content: this.getAutoPayType(EAutoPayType.BILL_FULL_DUE)
      }
    ]
  }

  get autoPayItemsTotal () {
    return this.$store.state.payments.autoPayItemsTotal
  }

  mounted () {
    this.showUpcoming = this.queryStatuses.includes(EAutoPayItemStatus.UPCOMING)
    this.$watch('queryStatuses', (value) => {
      if (value) {
        this.showUpcoming = value.includes(EAutoPayItemStatus.UPCOMING)
      }
    })
  }

  async fetchAutopay (filters: any) {
    if (!filters.statuses || !filters.statuses.length) {
      filters.statuses = [EAutoPayItemStatus.NEEDS_REVIEW, EAutoPayItemStatus.DECLINED, EAutoPayItemStatus.UPCOMING]
    }
    await this.paymentsModuleInstance.fetchChainAutoPayItemsByFilters(filters)
  }

  getAutoPayType (type: EAutoPayType) {
    const TYPE_LABELS: any = {
      [EAutoPayType.BILL_MAX_ONLY]: 'Up to Max Amount',
      [EAutoPayType.BILL_ANYWAY]: 'Fixed amount',
      [EAutoPayType.BILL_MONTH_DUE]: 'Monthly balance',
      [EAutoPayType.BILL_FULL_DUE]: 'Full balance'
    }
    return TYPE_LABELS[type]
  }

  toggleShowUpcoming (value: boolean) {
    this.showUpcoming = value
    this.filters = {
      skip: 0,
      limit: 20,
      statuses: !value
        ? [EAutoPayItemStatus.NEEDS_REVIEW, EAutoPayItemStatus.DECLINED]
        : [EAutoPayItemStatus.NEEDS_REVIEW, EAutoPayItemStatus.DECLINED, EAutoPayItemStatus.UPCOMING]
    }
  }

  goTo (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  goToEditPayment (autoPayItem: IAutoPayItem) {
    this.goTo({
      name: 'edit-payment-autopay',
      params: {
        settingId: (autoPayItem.setting as IAutoPaySetting).id,
        residentId: autoPayItem.resident
      }
    })
  }

  openReview () {
    this.$router.push({
      name: 'management-payments-review',
      params: { section: 'todo' }
    })
  }

  goReview (item: IAutoPayItem) {
    let section = 'todo'
    if (item.status === EAutoPayItemStatus.UPCOMING) {
      section = 'upcoming'
    }
    const facility = ((item.setting as IAutoPaySetting).resident as IResident).facility as IFacility
    const paymentMethod = (item.setting as IAutoPaySetting).paymentMethod as IResidentPaymentMethod
    if (!facility.allowCCProcessing && paymentMethod.type === EPaymentMethodType.CREDIT_CARD) {
      return
    }
    this.goTo({
      name: 'management-payments-review',
      params: {
        section: section,
        scheduleItemId: item.id
      }
    })
  }
}
